import { render, staticRenderFns } from "./EquipmentLicensesPatentsMarkirovka.vue?vue&type=template&id=2aa837e8&scoped=true"
import script from "./EquipmentLicensesPatentsMarkirovka.vue?vue&type=script&lang=js"
export * from "./EquipmentLicensesPatentsMarkirovka.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa837e8",
  null
  
)

export default component.exports